import { useState } from 'react';
import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';

const CATEGORIES = ['전체', '기초', '상징', '리딩', '스토리'] as const;

type Category = (typeof CATEGORIES)[number];

const ARTICLES: { tag: Exclude<Category, '전체'>; title: string; description: string }[] = [
  { tag: '기초', title: '타로 카드, 어디서부터 시작할까', description: '메이저 아르카나 22장의 큰 흐름을 따라가며 타로의 기본 구조를 소개합니다.' },
  { tag: '기초', title: '스프레드란 무엇인가', description: '한 장 뽑기부터 켈틱 크로스까지, 질문에 맞는 카드 배열을 고르는 법.' },
  { tag: '상징', title: '별과 태양, 그리고 달의 상징', description: '카드 속 천체 상징이 리딩에서 어떻게 읽히는지 정리했습니다.' },
  { tag: '상징', title: '컵과 검, 지팡이와 동전', description: '마이너 아르카나 네 슈트가 각각 담당하는 삶의 영역.' },
  { tag: '리딩', title: '좋은 질문이 좋은 리딩을 만든다', description: '"그 사람 나 좋아해요?"를 더 나은 질문으로 바꾸는 법.' },
  { tag: '스토리', title: '타로상담바라는 공간에 대하여', description: '2017년, 국내 최초 타로상담바가 문을 열기까지의 이야기.' }
];

export function ArchivePage() {
  const [category, setCategory] = useState<Category>('전체');
  const filtered = category === '전체' ? ARTICLES : ARTICLES.filter((article) => article.tag === category);

  return (
    <div className="tm-page">
      <Seo
        title="아카이브 | 타로맨스"
        description="카드 상징과 리딩의 기초, 타로맨스의 기록. 타로 콘텐츠 허브 아카이브입니다."
      />

      <section className="tm-page-hero">
        <div className="tm-container">
          <Reveal>
            <p className="tm-eyebrow">Archive</p>
            <h1 className="tm-display">
              타로를 읽는
              <br />
              <em>기록의 방</em>
            </h1>
            <p className="tm-lede">
              카드 해석과 리딩의 기초, 그리고 타로맨스가 만들어온 이야기를 모았습니다. 콘텐츠는 계속 추가됩니다.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="tm-section tm-section--tight">
        <div className="tm-container">
          <div className="tm-tabs" role="tablist" aria-label="아카이브 카테고리">
            {CATEGORIES.map((item) => (
              <button
                key={item}
                type="button"
                role="tab"
                aria-selected={category === item}
                className={category === item ? 'tm-tab is-active' : 'tm-tab'}
                onClick={() => setCategory(item)}
              >
                {item}
              </button>
            ))}
          </div>
          <div className="tm-content-grid">
            {filtered.map((article, index) => (
              <Reveal key={article.title} className="tm-content-card" delay={(index % 3) * 70}>
                <span className="tm-tag">{article.tag}</span>
                <h3 className="tm-h3">{article.title}</h3>
                <p className="tm-body-text">{article.description}</p>
              </Reveal>
            ))}
          </div>
          <p className="tm-body-text" style={{ marginTop: 36, textAlign: 'center', opacity: 0.7 }}>
            본문 콘텐츠는 순차적으로 공개될 예정입니다.
          </p>
        </div>
      </section>

      <CtaBand title="읽는 것보다 좋은 건, 직접 카드를 만나는 일." secondaryLabel="타로 상담 안내" secondaryTo="/tarot-consultation" />
    </div>
  );
}
